import { useContext, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';

import { Query } from '../generated/graphqlModels';
import { AuthContext } from '../context/AuthProvider';

const GET_SCHOOL_NAMESPACES = gql`
  query SchoolNamespaces {
    schools(
      filters: { namespace: { inList: ["hr", "bih", "slo", "philippines", "kodingnext"] } }
      pagination: { limit: 1 }
    ) {
      id
      namespace
    }
  }
`;

export const useShowSettings = () => {
  const [showSettings, setShowSettings] = useState(false);
  const user = useContext(AuthContext);
  const { data, loading, error } = useQuery<Query>(GET_SCHOOL_NAMESPACES, {
    // when signed out, user will be { is_authenticated: false }
    skip: user == null || user.pk == null,
  });

  useEffect(() => {
    if (loading || error || !data) {
      setShowSettings(false);
      return;
    }
    if (data.schools && data.schools.length === 0) {
      setShowSettings(false);
      return;
    }
    setShowSettings(true);
  }, [data, data?.schools, loading, error]);

  return showSettings;
};
